import {clearQueryCache} from '../api/reactQuery.ts';

export function setCurrentBusinessId(businessId: string | null) {
    clearQueryCache();
    if (businessId == null)
        localStorage.removeItem('current_business_id');
    else
        localStorage.setItem('current_business_id', businessId);
}

export function logInAsSubordinate(subordinateBusinessId: string) {
    setCurrentBusinessId(subordinateBusinessId)
    localStorage.setItem('viewAsSubordinate', '1');
    window.location.href = "/";
}


export function logInWithBusiness(businessId: string) {
    setCurrentBusinessId(businessId)
    localStorage.removeItem('viewAsSubordinate');
    window.location.href = "/";
}

export function logInWithBusinessAt(businessId: string, url: string) {
    setCurrentBusinessId(businessId)
    localStorage.removeItem('viewAsSubordinate');
    window.location.replace(url);
}

export function getCurrentBusiness(): string | null {
    return localStorage.getItem('current_business_id');
}

export function isViewingAsSubordinate(): boolean {
    return localStorage.getItem('viewAsSubordinate') === '1';
}

export function exitSubordinateView() {
    clearQueryCache();
    localStorage.removeItem('viewAsSubordinate');
    localStorage.removeItem('current_business_id');
    window.location.href = "/";
}
